import { DEFAULT_PRIORITY_COUNTS } from '../constants/inboxConstants';
import { applyInboxSessionFilters } from './inboxSessionFilters';

export const computePriorityCounts = (sessions, filterOptions = {}) => {
  const counts = { ...DEFAULT_PRIORITY_COUNTS };
  const filtered = applyInboxSessionFilters(sessions, {
    ...filterOptions,
    includePriorityFilter: false
  });

  filtered.forEach((session) => {
    if (session.priority && counts[session.priority] != null) {
      counts[session.priority] += 1;
    }
  });

  return counts;
};
